module.exports = __webpack_public_path__ + "static/media/sala_principal_5.8bf832d9.jpg";